import { DocumentCaptureOption } from 'lib/interfaces/documentConfig';

export const getSupportedDocumentCaptureOptions = (
  enabledCaptureOptions: DocumentCaptureOption[],
  isMobile: boolean,
  hasWebCamera: boolean,
) => {
  const showWebCameraOption =
    hasWebCamera && enabledCaptureOptions?.includes(DocumentCaptureOption.WebCamera);

  // These are listed in the order they appear (top to bottom on page)
  return [
    {
      option: DocumentCaptureOption.WebCamera,
      condition: showWebCameraOption,
    },
    {
      option: DocumentCaptureOption.MobileCamera,
      condition: !showWebCameraOption && isMobile,
    },
    {
      option: DocumentCaptureOption.Upload,
      condition: true,
    },
    {
      option: DocumentCaptureOption.ToMobile,
      condition: !isMobile,
    },
  ]
    .filter((opt) => opt.condition && enabledCaptureOptions?.includes(opt.option))
    .map((opt) => opt.option);
};
